import Skeleton from "react-loading-skeleton";
import { useProviderManagement } from "../hooks/ProviderManagementContext";
import styled from "styled-components";
import ProvidersRowActionCol from "./ProvidersGridRowActionCol";
import { openConfirmModal } from "../../../components/modals/ConfirmModal";

const TableCell = styled.td`
    width: ${props => props.width}%;
    max-width: 50px;
    vertical-align: middle;
`;

const ProvidersGridRow = ({ index, style: { height, width }, data }) => {

    const { columns, setProviderIdToEdit, deleteProvider } = useProviderManagement();

    if (!data[index]) {
        return <tr style={{ height, width }}>
            <td colSpan={columns.length}>
                <Skeleton height={height - 10} />
            </td>
        </tr>;
    }

    const {
        providerId,
        custodianCode,
        fundManagerCode,
        providerName
    } = data[index];

    const showConfirmDelete = () => {
        openConfirmModal({
            dialogTitle: "Delete Provider",
            message: `Are you sure you want to delete ${providerName ?? "this provider"}?`,
            confirmButtonText: "Delete",
            confirmButtonVariant: "danger"
        }).then(
            (proceed) => {
                if (proceed)
                    deleteProvider(providerId);
            }
        );
    }

    return <tr style={{ height, width }} onDoubleClick={() => setProviderIdToEdit(providerId)}>
        <TableCell width={25}>{providerName}</TableCell>
        <TableCell width={15}>{fundManagerCode}</TableCell>
        <TableCell width={58}>{custodianCode}</TableCell>
        <TableCell>
            <ProvidersRowActionCol
                deleteFn={showConfirmDelete}
                editFn={() => setProviderIdToEdit(providerId)}
            />
        </TableCell>
    </tr>;
};

export default ProvidersGridRow;